import { useEffect, useState } from 'react';

import { useHubsColumns } from './useHubsColumns';
import HubsExpandable from './HubsExpandable';

import { useAppDispatch } from 'slices';
import { setAdditionalInfo } from 'pages/Traps/Slice/trapSlice';
import { useGetHubs } from 'hooks/Traps/Hubs/useGetHubs';
import FilterDataTable from 'pages/VisitReports/FilterVisitReportListTable';
import { HubData } from 'api/traps/Hubs/types';
import useScreenSize from 'hooks/Screen/useScreenSize';
import ManageHubModal from 'pages/Traps/Modals/AddHubModal/ManageHubModal';
import EditHubModal from 'pages/Traps/Modals/EditHubModal/EditHubModal';
import HubDeleteModal from 'components/DeleteHubModal/HubsDeleteModal';

interface TableProps {
  slug: string;
}

const HubsTable: React.FC<TableProps> = ({ slug }) => {
  const [page, setPage] = useState(1);
  const [ordering, setQueryParam] = useState('');
  const [search, setSearch] = useState('');
  const { data, refetch, isLoading } = useGetHubs(slug || '', page, search, ordering);
  const { isNotDesktop } = useScreenSize();
  const columns = useHubsColumns(slug);
  const dispatch = useAppDispatch();

  useEffect(() => {
    refetch();
  }, [page, ordering, search, refetch]);

  useEffect(() => {
    dispatch(setAdditionalInfo({ totalTraps: data?.count || 0 }));
  }, [data, dispatch]);

  return (
    <div className="bg-white">
      <FilterDataTable<HubData>
        columns={columns}
        data={data?.results || []}
        totalPages={data?.count || 0}
        onChangePage={setPage}
        onChangeFilterParams={setQueryParam}
        onChangeSearch={setSearch}
        page={page}
        isLoading={isLoading}
        expandableRows={isNotDesktop}
        expandableRowsComponent={row => <HubsExpandable data={row.data} slug={slug} />}
      />
      <ManageHubModal refetchHubs={refetch} />
      <EditHubModal refetchHubs={refetch} />
      <HubDeleteModal hubs={data?.results} refetchHubs={refetch} />
    </div>
  );
};

export default HubsTable;
